import useAppToast from '@/hooks/useAppToast';
import { updateRezeptSheet } from '@/services/admin/rezeptSheetService';
import type { UpdateRezeptSheetPayload } from '@/types/admin-rezept-sheet';
import { getApiErrorMessage } from '@/utils/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const useUpdateRezeptSheet = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateRezeptSheetPayload }) =>
      updateRezeptSheet(currentSite, id, data),
    meta: { suppressNotFoundToast: true },
    onSuccess: async (_, variables) => {
      toast.success('更新しました。');
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['rezept-sheets', currentSite] }),
        queryClient.invalidateQueries({ queryKey: ['rezept-sheet', 'detail', currentSite, variables.id] }),
      ]);
    },
    onError: error => {
      toast.error(getApiErrorMessage(error, 'エラーが発生しました。'));
    },
  });

  return { updateRezeptSheet: mutateAsync, isPending };
};
